import { Dispatch, MouseEvent, SetStateAction } from 'react';

import { Row } from 'react-table';

import { Host } from 'hooks';
import { EHostType } from 'types';

export enum EHostModalType {
  ALL_BOOKINGS = 'ALL_BOOKINGS',
  BOOKING = 'BOOKING',

  SHOP = 'SHOP',
  CLIENT_DEPOSIT = 'CLIENT_DEPOSIT',
  MOVE_SESSION = 'MOVE_SESSION',
  STOP_CLIENT_SESSION = 'STOP_CLIENT_SESSION',
  PENALTY = 'PENALTY',

  MANAGE_HOST_GROUP = 'MANAGE_HOST_GROUP',
  MANAGE_HOST = 'MANAGE_HOST',

  COMMENTS = 'COMMENTS',

  RUN_FILE = 'RUN_FILE',
  SEND_MESSAGE = 'SEND_MESSAGE',
  NONE = 'NONE',

  GENERATE_QR = 'GENERATE_QR',

  // POST_PAYMENT = 'POST_PAYMENT',
  GENERATE_PIN = 'GENERATE_PIN',
}

export interface IHostCoordinates {
  x: number;
  y: number;
  hostType?: EHostType;
}

export interface IHostModalsData {
  type: EHostModalType;
  setType: (type: EHostModalType) => void;
  penalty: number | null;
  setPenalty: (penalty: number | null) => void;
  bookingIdForEdit: number | null;
  setBookingIdForEdit: (id: number | null) => void;
  selectedHostsIds: Array<number>;
  setSelectedHostsIds: React.Dispatch<React.SetStateAction<number[]>>;
  onHostClick: (
    event: MouseEvent,
    hostId: number,
    rowIndex?: number,
    flatRows?: Row<Host>[]
  ) => void;
  openShop: (hostId: number) => void;
  sidebarHostId: number | null;
  setSidebarHostId: (id: number | null) => void;
  unselectHosts: () => void;
  groupId: number | null;
  setGroupId: (id: number | null) => void;
  hostCoords: IHostCoordinates | null;
  setHostCoords: (coord: IHostCoordinates) => void;
  hosts?: Array<Host>;
}

export enum EMouseButton {
  'RIGHT' = 2,
  'LEFT' = 0,
}

export interface IHostModalsProps extends IHostModalsData {
  refetch: CallableFunction;
  stopPolling?: CallableFunction;
  statedPoling?: CallableFunction;
  setIsDepositOpen?: Dispatch<SetStateAction<boolean>>;
  setIsDefaultClient?: Dispatch<SetStateAction<string | undefined>>;
}
